// extracted by mini-css-extract-plugin
module.exports = {"theaterNameForm":"TheatreHTMLTitleForm_theaterNameForm__2ox3N","warning":"TheatreHTMLTitleForm_warning__1ldNT","input":"TheatreHTMLTitleForm_input__p6S9_"};